'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/lib/supabase';
import Icon from '@/components/ui/AppIcon';

export default function AdminEditButton({ entryId }: { entryId: string }) {
  const { user } = useAuth();
  const router = useRouter();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setIsAdmin(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_roles')
          .select('is_admin')
          .eq('user_id', user.id)
          .single();

        if (!error && data) {
          setIsAdmin(data.is_admin === true);
        } else {
          const role = user.user_metadata?.role;
          setIsAdmin(role === 'admin');
        }
      } catch {
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  if (!isAdmin) return null;

  return (
    <div data-component-id="src/app/entry-detail/components/AdminEditButton.tsx:45:4" data-component-path="src/app/entry-detail/components/AdminEditButton.tsx" data-component-line="45" data-component-end-line="53" data-component-file="AdminEditButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-end%20mb-4%22%7D" className="flex justify-end mb-4">
      <button data-component-id="src/app/entry-detail/components/AdminEditButton.tsx:46:6" data-component-path="src/app/entry-detail/components/AdminEditButton.tsx" data-component-line="46" data-component-end-line="52" data-component-file="AdminEditButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20px-4%20py-2%20rounded-md%20bg-primary%20text-primary-foreground%20font-medium%20transition-smooth%20hover%3Ashadow-editorial%20hover%3A-translate-y-px%22%7D"
        onClick={() => router.push(`/admin-entry-management/${entryId}/edit`)}
        className="flex items-center space-x-2 px-4 py-2 rounded-md bg-primary text-primary-foreground font-medium transition-smooth hover:shadow-editorial hover:-translate-y-px"
      >
        <Icon data-component-id="src/app/entry-detail/components/AdminEditButton.tsx:50:8" data-component-path="src/app/entry-detail/components/AdminEditButton.tsx" data-component-line="50" data-component-end-line="50" data-component-file="AdminEditButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PencilSquareIcon%22%7D" name="PencilSquareIcon" size={20} />
        <span data-component-id="src/app/entry-detail/components/AdminEditButton.tsx:51:8" data-component-path="src/app/entry-detail/components/AdminEditButton.tsx" data-component-line="51" data-component-end-line="51" data-component-file="AdminEditButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Edit%20Entry%22%7D">Edit Entry</span>
      </button>
    </div>
  );
}
